import { FilterType } from '../../filters/models/filter-type';
import { ListItem } from '../../filters/models/list-item';
import { ColumnDefinition } from './column-definition';
import { ColumnType } from './column-type';
import { DatasourceColumnDefinitionInterface } from './datasource-column-definition-interface';

/**
 * Représente la définition d'une colonne.
 */
export class ColumnListDefinition<T> extends ColumnDefinition implements DatasourceColumnDefinitionInterface<T> {
    constructor(
        public override columnName: string = null,
        public override headerText: string = null,
        public override filterType = FilterType.None,
        public override position: number = -1,
        public override size: number = 15,
        public override isVisible: boolean = true,
        public autoFill: boolean = true,
        public values: ListItem<T>[] = null
    ) {
        super(columnName, headerText, ColumnType.List, filterType, position, size, isVisible);

        if (values) {
            values.forEach((item, index) => {
                this.dataSource.set(item.value, item as unknown as ListItem<string>);
            });
        }
    }

    public dataSource: Map<T, ListItem<string>> = new Map();

    public override cell(row: Document): string {
        const cellValue = row[this.columnName];
        if (cellValue == null) {
            return '';
        } else {
            if (this.dataSource.size != 0) {
                if (Array.isArray(cellValue)) {
                    // TODO : avoir si possible de simplifier
                    return (cellValue as Array<T>)
                        .map((x) => `${x}`)
                        .map((x) => {
                            return this.dataSource.get(x as unknown as T)?.text;
                        })
                        .join(',');
                } else {
                    return `${this.dataSource.get(cellValue.toString())?.text}`;
                }
            } else {
                return '...';
            }
        }
    }
}
